import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Work } from "../../../types/work";
import AncillaryTable from "../../../components/tables/AncillaryTable";
import useAncillaryConnectionController from "../../../controllers/connections/AncillaryConnectionController";

interface AncillarySectionProps {
  work: Work;
  systemLanguageType: Work["system_language_type"];
}

const AncillarySection: React.FC<AncillarySectionProps> = ({ work, systemLanguageType }) => {
  const controller = useAncillaryConnectionController({ from: work });
  const { openCreateDialog } = controller;

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          mb: 4,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{ position: "absolute", left: 16 }}
          startIcon={<AddIcon />}
          onClick={() => openCreateDialog()}
        >
          New Ancillary
        </Button>
        <Typography variant="h2">Ancillary</Typography>
      </Box>

      <AncillaryTable
        controller={controller}
        systemLanguageType={systemLanguageType}
      />
    </Box>
  );
};

export default AncillarySection;
